import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchVideos = async (params = {}) =>
    (await api.get("/videos", { params })).data;
export const fetchCategories = async () =>
    (await api.get("/videos/categories")).data;
export const fetchFestivals = async (params = {}) =>
    (await api.get("/festivals", { params })).data;
export const fetchFestival = async (id) =>
    (await api.get(`/festivals/${id}`)).data;
export const generateFestivalSummary = async (id) =>
    (await api.post(`/festivals/${id}/summary`)).data;
export const fetchDailyShloka = async () =>
    (await api.get("/shloka/daily")).data;
export const subscribeNewsletter = async (email) =>
    (await api.post("/newsletter/subscribe", { email })).data;
